/* =========================================
   UGLY MUG — SHOPIFY CART DRAWER
   ========================================= */

(function () {

  const SHIPPING_COPY =
    "Standard shipping's on us. Express options available at checkout.";


  /* =========================================
     SHIPPING COPY
     ========================================= */

  function updateCartDrawerShippingCopy() {

    document.querySelectorAll(
      '.cart-drawer__summary .cart-totals__tax-note'
    ).forEach(function (note) {

      if (
        note.querySelector('small') &&
        note.textContent.trim() === SHIPPING_COPY
      ) {
        return;
      }

      const small = document.createElement('small');

      small.textContent = SHIPPING_COPY;

      note.replaceChildren(small);

    });

  }


  /* =========================================
     CONTINUE SHOPPING
     ========================================= */

  function addContinueShoppingButton() {

    document.querySelectorAll(
      '.cart-drawer__summary'
    ).forEach(function (summary) {

      /* Prevent duplicate buttons */
      if (
        summary.querySelector(
          '.ugly-continue-shopping'
        )
      ) {
        return;
      }


      /* Preferred position:
         directly beneath express checkout buttons */
      const acceleratedCheckout =
        summary.querySelector(
          '.additional-checkout-buttons'
        );


      /* Fallback:
         beneath normal Checkout if accelerated
         buttons ever aren't available */
      const checkoutButton =
        summary.querySelector(
          '#checkout'
        );


      const insertionPoint =
        acceleratedCheckout || checkoutButton;


      if (!insertionPoint) {
        return;
      }


      const button =
        document.createElement('button');

      button.type = 'button';

      button.className =
        'ugly-continue-shopping';

      button.textContent =
        'Continue shopping';


      button.addEventListener(
        'click',
        function () {

          const closeButton =
            document.querySelector(
              '.cart-drawer__close-button'
            );

          if (closeButton) {
            closeButton.click();
          }

        }
      );


      insertionPoint.insertAdjacentElement(
        'afterend',
        button
      );

    });

  }


  /* =========================================
     UPDATE DRAWER
     ========================================= */

  function updateUglyMugCartDrawer() {

    updateCartDrawerShippingCopy();

    addContinueShoppingButton();

  }


  /* Run when script loads */
  updateUglyMugCartDrawer();


  /* Shopify dynamically rebuilds the cart drawer,
     so restore our changes whenever necessary */

  const observer =
    new MutationObserver(function () {

      updateUglyMugCartDrawer();

    });


  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );

})();